<template>
    <div class="tabs-container relative">
        <el-tabs v-model="activeTabModel" v-bind="$attrs" class="widget--group_section relative">
            <el-tab-pane v-for="(tab, index) in tabs" :label="tab.WidgetGroupTitle" :name="tab.WidgetGroupID.toString()"
                         :key="tab.WidgetGroupID.toString()"
            >
                <slot :tab="tab"
                      :activeTab="activeTabModel"
                      :index="index"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import get from 'lodash/get'
import { Tabs, TabPane } from 'element-ui'

export default {
    inheritAttrs: false,
    props: {
        circularTimeout: Number,
        tabs: {
            type: Array,
            default: () => [],
        },
        activeTab: [String, Number]
    },
    components: {
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    data() {
        return {
            timeout: null,
        };
    },
    computed: {
        activeTabModel: {
            get () {
                return String(this.activeTab) || get(this.tabs, '[0].WidgetGroupID').toString()
            },
            set (val) {
                this.$emit('switch-tab', val)
            }
        }
    },
    methods: {
        changeActiveTab() {
            const index = this.tabs.findIndex(e => e.WidgetGroupID.toString() === this.activeTabModel);

            if (index === -1) {
                return;
            }

            if (index < this.tabs.length - 1) {
                this.activeTabModel = (this.tabs[index + 1].WidgetGroupID).toString();
            } else {
                this.activeTabModel = get(this.tabs, '[0].WidgetGroupID').toString()
            }
        },
        triggerCircularTimeout() {
            clearInterval(this.timeout)
            if (this.circularTimeout) {
                this.timeout = setInterval(this.changeActiveTab, this.circularTimeout * 1000);
            }
        },
        setActiveTab(value) {
            if (!value) {
                return
            }
            if (this.isTabValid(value)) {
                this.activeTabModel = value.toString()
            }
        },
        isTabValid(value) {
            const tabValues = this.tabs.map(t => t.WidgetGroupID.toString())
            return tabValues.includes(value.toString())
        },

    },
    watch: {
        circularTimeout: {
            immediate: true,
            handler: function () {
                this.triggerCircularTimeout()
            },
        },
        newActiveTab: {
            immediate: true,
            handler(val) {
                this.setActiveTab(val)
            },
        },
        tabs: {
            deep: true,
            handler(val) {
                if (!this.isTabValid(this.activeTabModel)) {
                    this.activeTabModel = get(val, '[0].WidgetGroupID').toString()
                }
            },
        }
    },
    beforeDestroy() {
        clearInterval(this.timeout)
    },
}
</script>
<style lang="scss">
.tabs-container {
    .el-tabs__header {
        display: none;
    }

    .el-tabs__nav-scroll {
        @apply px-2;
    }

    .el-tabs__nav-wrap::after {
        background-color: transparent;
    }

    .el-tabs__active-bar {
        height: 2px;
        border-radius: 4.5px;
    }

    .el-tabs__item {
        height: 48px;
        padding: 5px 20px;
        color: var(--steel);
        cursor: pointer;
        font-size: 14px;
    }

    .el-tabs__nav-next, .el-tabs__nav-prev {
        line-height: 50px;
        font-size: 20px;
    }
}
</style>
